import React from 'react';
import resume from '../assets/doc/Ganesh_Pataiya_Resume.pdf';
import ExternalLink from './externalLinkIcon';
const Resume = () => {
  return (
    <>
      <a href={resume} target='_blank' rel="noreferrer" className="flex resume items-center hover:text-violet-300 focus-visible:text-violet-300"><h3>View Full Résumé</h3> <ExternalLink className="color:text-violet-300" /></a>
    </>
  );
};

export default Resume;